export default __webpack_public_path__ + "static/media/remove-session.d183a843.png";